<script setup lang="ts">
import { onMounted } from 'vue';
import { useAuthStore } from '@/stores/auth';
import { useSiteStore } from '@/stores/site';
import { ToastsHost } from '@mcpsite/ui';
import { ConfirmHost } from '@mcpsite/ui';

const auth = useAuthStore();
const site = useSiteStore();
// load сайта при авторизации
onMounted(() => {
  if (auth.isAuthed && !site.site) void site.load();
});

// авто-логаут по сессии в API-клиенте шлёт toast; перенаправление на /login
</script>

<template>
  <RouterView />
  <ToastsHost />
  <ConfirmHost />
</template>